import { addReadoutFieldStmtInstruction } from './AddReadoutFieldStmt';
import { createReadoutStmtInstruction } from './CreateReadoutStmt';
import { removeReadoutFieldStmtInstruction } from './RemoveReadoutFieldStmt';
import { removeReadoutStmtInstruction } from './RemoveReadoutStmt';
export const readoutInstruction = `
## Readout
It's a group of fields that define how the Entity readout will looks like. Similar to Form, but it's read-only and formatted for better readability. Readout can be connected to detail scopes.

### Readout commands

${createReadoutStmtInstruction}
${removeReadoutStmtInstruction}
${addReadoutFieldStmtInstruction}
${removeReadoutFieldStmtInstruction}
`;
//# sourceMappingURL=readoutInstruction.js.map